import api from './api';

export const getById = (user, config) => {
    let errors = [];
    if (!user) {
        errors.push('user');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/users/GetById/${user.id}`, config);
    }
}

export const deleteAllCartItems = (user, config) => {
    let errors = [];
    if (!user) {
        errors.push('user');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.delete(`/Cart/DeleteAllCartItems/${user != null ? user?.id : ""}`, config);
    }

}

export const addOrder = (user, params, orderObject, config) => {
    let errors = [];
    if (!user) {
        errors.push('user');
    }
    if (!params) {
        errors.push('params');
    }
    if (!orderObject) {
        errors.push('order object');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.post(`/Order/AddOrder/${(user != null && user != undefined) ? user?.id : null}/${params?.checkoutType}`, orderObject, config);
    }
}
